let multiLang = {
	'zh-CN': {
		required: '此项为必填',
		phoneErr: '请正确填写手机号码',
		emailErr: '邮箱格式不正确',
		more: '更多',
	},
	'en-US': {
		required: 'This field is required',
		phoneErr: 'Please enter valid phone numbers',
		more: 'More',
		fillFirstName: 'Please enter your first name.',
		fillLastName: 'Please enter your last name.',
		fillEmail: 'Please enter your email address.',
		emailErr: 'The email address format is incorrect.',
		fillRegion: 'Please enter your country/region.',
		selectType: 'Please select a consultation type.',
		fillName: 'Please enter your name',
	},
};

export default function Language() {
	const langCode = document.documentElement.getAttribute('lang');

	let lang = multiLang[langCode];

	return lang;
}
